import React, { Component } from "react";
import axios from "axios";

import { BACKEND_CONFIG } from "../../config/consts";

import LeadOptimizationService from "./LeadOptimization";
import Typeahead from "./Typeahead";

class StartApplicationPage extends Component {
  constructor() {
    super();

    this.state = {
      premierStatus: false,
      categories: [],
      busClasses: [],
      selectedBusClassKey: "",
      selectedBusClassInefficency: null,
      categorySelected: false,
      categoryInefficent: false,
      submitLink: "",
      dataToken: "",
      clientId: "",
      isTypeaheadEnabled:
        BACKEND_CONFIG.get("startApplicationPageComponent") === "Typeahead",
    };
    this.formId = "startAppForm";
  }

  handleWindowChange = () => {
    this.setState({
      isTypeaheadEnabled:
        BACKEND_CONFIG.get("startApplicationPageComponent") === "Typeahead",
    });
  };

  componentDidMount() {
    axios
      .get(`${BACKEND_CONFIG.apiUrl}start-application/categories/`)
      .then((data) => {
        this.setState({
          categories: data.data.IndustriesServices,
        });
      });

    axios
      .get(`${BACKEND_CONFIG.apiUrl}allstateagency/premierstatus/`)
      .then((data) => {
        this.setState({
          premierStatus: data.data,
        });
      });

    window.addEventListener(
      "backendConfigChange",
      this.handleWindowChange,
      false
    );
  }

  componentWillUnmount() {
    window.removeEventListener("backendConfigChange", this.handleWindowChange);
  }

  handleSelect = (webBusClassIdDescription) => {
    const webBusClassId = webBusClassIdDescription.split("|")[0];
    const webBusClassIdNumber = Number(webBusClassId);

    const services = this.state.categories.reduce(
      (services, category) => [...services, ...category.Services],
      []
    );

    const webBusClass = services.find(
      (webBusClass) => webBusClass.Id === webBusClassIdNumber
    );

    this.setState({
      selectedBusClassKey: webBusClassId,
      selectedBusClassInefficency:
        webBusClass?.InefficiencyType !== undefined
          ? webBusClass?.InefficiencyType
          : null,
    });

    if (webBusClass?.InefficiencyType !== undefined) {
      return;
    }
  };

  render() {
    if (this.state.isTypeaheadEnabled === null) {
      return null;
    }

    return (
      <div className="start-app-page">
        <div className="start-app-content">
          <h1 className="mb-5" style={{ color: "#00bef3", marginBottom: 0 }}>What kind of work do you do?</h1>
          <h2 style={{ textAlign: "left" }}>Search and select the closest match</h2>
          <div className="start-app-container">
            {this.state.isTypeaheadEnabled ? (
              <>
                <Typeahead
                  data-testid="industrytypeahead"
                  dropdownClassName="homepage-typeahead"
                  onClientChange={(clientId) => this.setState({ clientId })}
                  onSelect={this.handleSelect}
                />
                {this.state.selectedBusClassInefficency !== null &&
                  !this.state.premierStatus && (
                    <div style={{ paddingTop: 20 }}>
                      <LeadOptimizationService
                        inefficencyType={this.state.selectedBusClassInefficency}
                      />
                    </div>
                  )}
              </>
            ) : (
              <div className="start-app-label">
                <span>Industry</span>
                <select
                  className="mt-2 mb-4"
                  defaultValue={""}
                  onChange={(e) => this.handleSelectCategory(e.target.value)}
                >
                  <option value="" className="default-option" disabled>
                    What's your industry
                  </option>
                  {this.state.categories.map((category, index) => (
                    <option value={category.Id} key={`${category.Id}${index}`}>
                      {category.Description}
                    </option>
                  ))}
                </select>
                {this.state.categoryInefficent && !this.state.premierStatus && (
                  <LeadOptimizationService
                    inefficencyType={this.state.busClasses[0].InefficiencyType}
                  />
                )}
                <span>Profession</span>
                <select
                  className="mt-2 mb-4"
                  value={this.state.selectedBusClassKey}
                  disabled={
                    !this.state.categorySelected ||
                    (this.state.categoryInefficent && !this.state.premierStatus)
                  }
                  onChange={(e) => {
                    this.handleSelectProfession(e.target.value);
                  }}
                >
                  <option value="" className="default-option" disabled>
                    What service do you provide?
                  </option>
                  {this.state.busClasses.map((busClass) => (
                    <option
                      value={busClass.Id + "|" + busClass.Description}
                      key={busClass.Id + busClass.Description}
                    >
                      {busClass.Description}
                    </option>
                  ))}
                </select>
                {this.state.selectedBusClassInefficency !== null &&
                  !this.state.premierStatus && (
                    <LeadOptimizationService
                      inefficencyType={this.state.selectedBusClassInefficency}
                    />
                  )}
              </div>
            )}
            <button
              disabled={
                this.state.selectedBusClassKey === "" ||
                (this.state.selectedBusClassInefficency !== null &&
                  !this.state.premierStatus)
              }
              className="btn btn-primary float-right mt-4"
              onClick={() => this.handleContinue()}
            >
              Continue
            </button>
          </div>
          <form id="startAppForm" action={this.state.submitLink} method="post">
            <input type="hidden" name="token" value={this.state.dataToken} />
          </form>
        </div>
        <div>
          <p className="start-app-info mt-5 clearfix">
            <b>Authorization Disclaimer</b>: To provide an accurate price and a
            bindable quote, the quoting carriers may utilize business or
            personal credit reports, as well as other consumer reports, for
            underwriting and rating purposes. By continuing and submitting this
            application, you confirm that you have obtained your customer’s
            consent to proceed with the credit and consumer report checks.
          </p>
          <p className="start-app-info" style={{ marginBottom: 0 }}>
            <b>NOTICE:</b> Additional coverages and limits may not be
            available. Each carrier has different optional coverages and will
            vary carrier to carrier. Coverages, limits or deductibles may be
            changed to fit your customer’s individual situation and needs.
            Policy issuance is subject to qualifications. Coverages and
            discounts are subject to terms, conditions and limitations. These
            estimated quotes are not a contract or binder of insurance. These
            premiums are an estimate based upon the information provided and
            are subject to change. To apply for insurance, you must complete
            the application process. Rates subject to change. Additional fees,
            surcharges, discounts, exclusions or other limitations may apply.
            Please refer to carrier proposal regarding your specific coverages
            provided and if you do not see those coverages please ask.
          </p>
        </div>
      </div>
    );
  }

  handleSelectCategory(categoryId) {
    this.setState((state) => {
      const services = state.categories.find((category) => {
        return category.Id === Number(categoryId);
      });

      return {
        busClasses: services.Services,
        selectedBusClassKey: "",
        selectedBusClassInefficency: null,
        categorySelected: true,

        categoryInefficent:
          services.Services.length > 0 &&
          services.Services.every(
            (busClass) => busClass.InefficiencyType !== undefined
          ) &&
          services.Services.every(
            (busClass) =>
              busClass.InefficiencyType ===
              services.Services[0].InefficiencyType
          ),
      };
    });
  }

  componentDidUpdate() {
    if (this.state.submitLink !== "" && this.state.dataToken !== "") {
      setTimeout(() => {
        document.getElementById(this.formId).submit();
      });
    }
  }

  handleContinue() {
    const webBusClassId = this.state.selectedBusClassKey.split("|")[0];

    axios
      .get(
        `${BACKEND_CONFIG.apiUrl}start-application-v2/${webBusClassId}${this.state.clientId ? `?clientId=${this.state.clientId}` : ""
        }`
      )
      .then((response) => {
        if (response.data.result === "redirect") {
          const requestUrl = new URL(response.data.requestUrl);

          if (this.state.clientId) {
            requestUrl.searchParams.append("clientId", this.state.clientId);
          }

          this.setState({
            submitLink: requestUrl.toString(),
            dataToken: response.data.token,
          });
        }
      });
  }

  handleSelectProfession(professionId) {
    let webBusClassIndex = professionId.indexOf("|");
    let webBusClassId = professionId.substring(0, webBusClassIndex);
    let webBusClass = this.state.busClasses.find(
      (busClass) => busClass.Id === Number(webBusClassId)
    );

    this.setState({
      selectedBusClassKey: professionId,
      selectedBusClassInefficency:
        webBusClass?.InefficiencyType !== undefined
          ? webBusClass?.InefficiencyType
          : null,
    });
  }
}

export default StartApplicationPage;
